module.exports = __webpack_public_path__ + "img/08.38429ec5.jpg";